const translations = {
    de: {
        fullAddress: {
            emptyState: 'Keine Adresse gefunden',
            emptyFilter: 'Bitte geben Sie eine gültige Adresse ein',
        },
        postal: {
            emptyState: 'Keine Postleitzahl gefunden',
            emptyFilter: 'Bitte geben Sie eine gültige Postleitzahl ein',
        },
        street: {
            emptyState: 'Keine Strasse gefunden',
            emptyFilter: 'Bitte geben Sie eine gültige Strasse ein',
        },
        city: {
            emptyState: 'Keine Stadt gefunden',
            emptyFilter: 'Bitte geben Sie einen gültigen Stadtnamen ein',
        },
        noCountryFound: 'Kein Land gefunden',
        validation: {
            Required: 'Dies ist ein Pflichtfeld',
            EmptyText: 'Bitte geben Sie einen gültigen Text ein',
            InvalidNumber: 'Bitte geben Sie eine gültige Nummer ein',
            InvalidPhone: 'Bitte geben Sie eine gültige Telefonnummer ein',
            PhoneTooLong: 'Diese Telefonnummer sieht zu lang aus',
            PhoneTooShort: 'Diese Telefonnummer sieht zu kurz aus',
            InvalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
            InvalidUrl: 'Bitte geben Sie eine gültige URL ein',
            InvalidBirthday: 'Bitte geben Sie ein gültiges Geburtsdatum ein',
            PublicEmail: 'Bitte geben Sie Ihre geschäftliche E-Mail-Adresse ein',
            InvalidFile: 'Bitte probieren Sie ein anderes Dateiformat',
            FileTooLarge: 'Bitte probieren Sie es mit einer kleineren Datei',
            TooManyFiles: 'Bitte versuchen Sie es mit einer einzigen Datei',
        },
    },
    en: {
        fullAddress: {
            emptyState: 'No address found',
            emptyFilter: 'Please enter a valid address',
        },
        postal: {
            emptyState: 'No postcode found',
            emptyFilter: 'Please enter a postcode',
        },
        street: {
            emptyState: 'No street found',
            emptyFilter: 'Please enter a street name',
        },
        city: {
            emptyState: 'No city found',
            emptyFilter: 'Please enter a city name',
        },
        noCountryFound: 'No country found',
        validation: {
            Required: 'This is a required field',
            EmptyText: 'Please enter a valid text',
            InvalidNumber: 'Please enter a valid number',
            InvalidPhone: 'Please enter a valid phone',
            PhoneTooLong: 'This phone number looks too long',
            PhoneTooShort: 'This phone number looks too short',
            InvalidEmail: 'Please enter a valid email',
            InvalidUrl: 'Please enter a valid URL',
            InvalidBirthday: 'Please enter a valid birthday',
            PublicEmail: 'Please enter a work email address',
            InvalidFile: 'Please try a different file format',
            FileTooLarge: 'Please try with a smaller file',
            TooManyFiles: 'Please try with a single file',
        },
    },
};

export default translations;
